import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/Layout';
import Home from './pages/Home';
import Certificaciones from './pages/Certificaciones';
import Servicios from './pages/Servicios';
import EconomiaCircular from './pages/EconomiaCircular';
import LeyREP from './pages/LeyREP';
import Nosotros from './pages/Nosotros';
import Medios from './pages/Medios';
import Contacto from './pages/Contacto';
import PlaceholderPage from './pages/PlaceholderPage';

export default function App() {
  useEffect(() => {
    document.body.classList.add('has-header', 'minimal-header', 'wsite-theme-light', 'postload');
    return () => {
      document.body.classList.remove('has-header', 'minimal-header', 'wsite-theme-light', 'postload');
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/certificaciones" element={<Certificaciones />} />
          <Route path="/certificaciones.html" element={<Navigate to="/certificaciones" replace />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/servicios.html" element={<Navigate to="/servicios" replace />} />
          <Route path="/economia-circular" element={<EconomiaCircular />} />
          <Route path="/economia-circular.html" element={<Navigate to="/economia-circular" replace />} />
          <Route path="/ley-rep" element={<LeyREP />} />
          <Route path="/ley-rep.html" element={<Navigate to="/ley-rep" replace />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/nosotros.html" element={<Navigate to="/nosotros" replace />} />
          <Route path="/medios" element={<Medios />} />
          <Route path="/medios.html" element={<Navigate to="/medios" replace />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/contacto.html" element={<Navigate to="/contacto" replace />} />
          <Route path="*" element={<PlaceholderPage title="Página no encontrada" intro="La ruta solicitada no existe." />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
